import { create } from 'zustand';
import { Filter } from '@libs/models/common';
import { activateFacility, deactivateFacility, fetchFacilitiesList } from '@libs/api/facilities';
import { FacilityListItem } from '@libs/models/facilities';

type InitialState = {
  initialized: boolean;
  loadingList: boolean;
  facilities: FacilityListItem[];
  page: number;
  perPage: number;
  total: number;
  loadFacilities: (filters?: Filter[], page?: number, perPage?: number) => Promise<void>;
  activateFacility: (id: string) => Promise<void>;
  deactivateFacility: (id: string) => Promise<void>;
};

export const useFacilitiesListStore = create<InitialState>()((set) => ({
  initialized: false,
  loadingList: false,
  facilities: [],
  page: 1,
  perPage: 50,
  total: 0,

  loadFacilities: async (filters, page = 1, perPage = 50) => {
    set({ loadingList: true });
    try {
      const resp = await fetchFacilitiesList({ filters, page, size: perPage });
      set({
        loadingList: false,
        initialized: true,
        facilities: resp.items,
        page,
        perPage,
        total: resp.totalCount,
      });
    } finally {
      set({ loadingList: false, initialized: true });
    }
  },
  activateFacility: async (id: string) => {
    const resp = await activateFacility(id);
  },
  deactivateFacility: async (id: string) => {
    const resp = await deactivateFacility(id);
  },
}));
